import { List } from '@common/typescript/objects/List';
import { WithDeleted } from '@common/typescript/objects/WithDeleted';
import { Nullable } from '@common/typescript/objects/Nullable';
import { IPublished } from '@common/typescript/objects/IPublished';
import { IAvatarTarget } from '@common/typescript/objects/IAvatarTarget';
import { Page as BasePage, PageInfo as BasePageInfo } from '@common/typescript/objects/Page';
import { WithFile } from '@common/typescript/objects/WithFile';

import { CasePage } from '@commonTuna/react/objects/BaseCase';
import { FaqPage } from '@commonTuna/react/objects/FaqPage';
import { ReviewPage } from '@commonTuna/react/objects/ReviewPage';
import { Review } from '@commonTuna/react/objects/Review';
import { BaseDoctor } from '@commonTuna/react/objects/BaseDoctor';

export interface PagePage {
	parent: NTPage;
	id: number;
	deleted: boolean;
	pageId: number;
	parentId: number;
}

export enum FactsBlock {
	None = 0,
	Left = 1,
	Right = 2
}

export enum Anesthesia {
	None = 0,
	General = 1,
	Sedation = 2,
	Regional = 3,
	Local = 4
}

export enum PageType {
	PAGE = 0,
	SERVICE = 1
}

export interface PageInfo extends BasePageInfo {
	shortBody: string;
	author: string;
}

export interface LangsInfo {
	titleEn: string;
	titleEs: string;
	textEn: string;
	textEs: string;
}

export interface PageImage extends WithFile<Page>, LangsInfo {

}

export interface PageVideo extends WithDeleted, LangsInfo {
	page: Page;
	pageId: number;
	url: string;
}

export interface NTPage extends BasePage<PageInfo>, IPublished, IAvatarTarget {
	pageType: PageType;
	fullPath: string;
	shortNameEn: string;
	shortNameEs: string;
	updateTime: number;
	pages: List<PagePage>;
	children: List<NTPage>;
	show: boolean;
	menu: boolean;
	text: string;
	parentPage: Nullable<Page>;
	pathEs: string;
	fullPathEs: string;
}

// todo rename it to ServicePage
export interface Page extends NTPage {
	anesthesia: Anesthesia;
	author?: BaseDoctor;
	duration: string;
	factsBlock: FactsBlock;
	tagLineEn: string;
	tagLineEs: string;
	purposeEn: string;
	purposeEs: string;
	files: Array<PageImage>;
	videos: Array<PageVideo>;
	surgeryLength: string;
	recoveryTime: string;
	cases: Array<CasePage>;
	faqs: Array<FaqPage>;
	reviews: Array<ReviewPage>;
	randomReviews: Array<Review>;
}

// for clients sites
export interface NTBaseItemPage<TEntity> extends NTPage {
	item: TEntity;
}

export interface NTBaseItemsPage<TEntity> extends NTPage {
	items: List<TEntity>;
}

export interface NTBaseItemOrItemsPage<TEntity, TEntities = TEntity> extends NTBaseItemPage<TEntity> {
	items: List<TEntities>;
}
